import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <Section tone="tint" eyebrow="Testimonios" title="Lo que dicen quienes ya utilizan el material" width="narrow" data-id="element-181" data-mp="3fze2zvj28zum">
      <ul className="mx-auto max-w-narrow divide-y divide-blue-200/70" data-id="element-182" data-mp="3b143x9u7tf3q">
        {testimonials.map(item => <li key={`${item.author}-${item.city}`} className="grid gap-4 py-7 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,15rem)_1fr] md:gap-10" data-id="element-183" data-mp="3700qsv3jxx67">
            <div className="flex items-start gap-3" data-id="element-184" data-mp="2x09xgwqq9o7p">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-600 font-display text-xs font-bold text-white" data-id="element-185" data-mp="2x11pxyp135tr">
                {item.initials}
              </span>
              <span data-id="element-186" data-mp="v7c85aw5tdri">
                <span className="flex gap-0.5" role="img" aria-label="5 de 5 estrellas" data-id="element-187" data-mp="qac0ivjnw2ya">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-blue-500 text-blue-500" aria-hidden="true" data-id="element-188" data-mp="h4deiq6avw6a" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-display font-extrabold tracking-tight text-ink" data-id="element-189" data-mp="78abli3mjtia">
                  {item.author}
                </span>
                <span className="block text-sm text-blue-900/70" data-id="element-190" data-mp="c73pvcqqjoji">{item.role}</span>
                <span className="inline-flex items-center gap-1 text-sm text-blue-900/60" data-id="element-191" data-mp="zwy2bt757b38">
                  <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-192" data-mp="14u7p1135d8nd" />
                  {item.city}
                </span>
              </span>
            </div>
            <blockquote className="text-lg italic leading-relaxed text-ink md:text-xl" data-id="element-193" data-mp="v5fxuv5wusdi">
              “{item.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}